__turbopack_context__.v({
  "feedback-btn": "FaqFeedback-module-scss-module__Ea0-8a__feedback-btn",
  "loading-feedback-icon": "FaqFeedback-module-scss-module__Ea0-8a__loading-feedback-icon",
});
